export enum LoginAndRegistrationDialogTabEnum {
    Login,
    Registration
}
